import { render, staticRenderFns } from "./Porque.vue?vue&type=template&id=34367794&scoped=true&"
import script from "./Porque.vue?vue&type=script&lang=js&"
export * from "./Porque.vue?vue&type=script&lang=js&"
import style0 from "./Porque.vue?vue&type=style&index=0&id=34367794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34367794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34367794')) {
      api.createRecord('34367794', component.options)
    } else {
      api.reload('34367794', component.options)
    }
    module.hot.accept("./Porque.vue?vue&type=template&id=34367794&scoped=true&", function () {
      api.rerender('34367794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/Porque.vue"
export default component.exports